import { Box, Button, IconButton, Popover, Tab, Tabs } from '@mui/material';
import React, { useEffect, useState } from 'react';

import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { CustomStack } from "@components/Styles/CommonStyle";

import dayjs from "dayjs";
import api from "@api/axios";
import Sales from '@containers/project/Sales';
import Purchases from '@containers/project/Purchases';
import Outsourcing from '@containers/project/Outsourcing';
import { downloadExcelFile } from '@utils/excel';
import moment from 'moment';

const SalesPurchaseManagement = () => {
  // sales : 매출, purchases : 매입, outsourcing : 외부인건비
  const [pageType, setPageType] = useState("sales");
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [monthlyFinanceList, setMonthlyFinanceList] = useState([]);
  const [monthlyFinanceListTotal, setMonthlyFinanceListTotal] = useState(0);
  const [monthlyFinanceListTotalAmount, setMonthlyFinanceListTotalAmount] = useState(0);
  const [projectName, setProjectName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(30);
  const [orderBy, setOrderBy] = useState("pmfl_account_company_name");
  const [orderDir, setOrderDir] = useState("ASC");

  const handleChange = (event, newValue) => {
    setPageType(newValue);
    setProjectName("");
    setCompanyName("");
  };

  const getMonthlyFinanceList = async (page = 1) => {

    const year = selectedDate.year();
    const month = selectedDate.month() + 1;
    let financeType = "";

    // console.log("getMonthlyFinanceList :: year :: " + year);
    // console.log("getMonthlyFinanceList :: month :: " + month);
    // console.log("getMonthlyFinanceList :: page :: " + page);

    // 페이지 번호 설정 (페이지 번호 클릭 시)
    if (page) setPage(page);

    if (pageType === "sales") {
      financeType = "매출";
    } else if (pageType === "purchases") {
      financeType = "매입";
    } else if (pageType === "outsourcing") {
      financeType = "외부인건비";
    }

    const response = await api.get(`/api/project/readMonthlyFinanceList`, {
      params: {
        year: year,
        month: month,
        financeType: financeType,
        projectName: projectName,
        companyName: companyName,
        page: page,
        limit: limit,
        orderBy: orderBy,
        orderDir: orderDir
      }
    });

    // 응답 성공시 월별 장부 목록 설정
    if (response.status === 200) {  
      console.log('매출매입관리 :: response');
      console.log(response);

      setMonthlyFinanceList(response.data.result.resultArr);
      setMonthlyFinanceListTotal(response.data.result.totalCount);
      setMonthlyFinanceListTotalAmount(Number(response.data.result.totalAmount));
    }
  }

  // 매입, 외부인건비 조회 엑셀 다운로드
  const getSeachExcel = (type) => {
    if (monthlyFinanceList && monthlyFinanceList.length > 0) {
      let excel_list = monthlyFinanceList;
      excel_list = excel_list.map((v, i) => {
        let after_value = {};

        // 매입
        if (type ==='purchases') {
          after_value = {
            매입처: v.pmfl_account_company_name,
            사업명: v.project_name,
            공급금액: v.pmfl_sales_amount,
            부가세: Math.ceil(v.pmfl_sales_amount * 0.1),
            합계금액: v.pmfl_sales_amount + Math.ceil(v.pmfl_sales_amount * 0.1),
          };
        }
        // 외부인건비
        else if (type === 'outsourcing') { 
          after_value = {
            성명: v.pmfl_account_company_name,
            사업명: v.project_name,
            금액: v.pmfl_sales_amount,
            지급금액: Math.ceil(v.pmfl_sales_amount * 0.967)
          };
        }

        return after_value;
      });

      if (excel_list.length > 0) {
        downloadExcelFile(excel_list, `매출매입관리_조회내역_${moment().format('YYYYMMDDhhmmss')}.xlsx`, `${moment().format('YYYYMMDD')}`);
      } else {
        alert('조회 목록이 없습니다.');
      }
    } else {
      alert('엑셀 다운로드에 실패했습니다.');
    }
  };

  // 매입, 외부인건비 조회 지급 양식 엑셀 다운로드
  const getPaymentExcel = (type) => {
    // 선택 날짜
    const yearStr = selectedDate.year().toString();
    // 아래 값을 MM 형식으로 변경
    const month = selectedDate.month() + 1;
    const monthStr = month.toString().padStart(2, '0');

    // 엑셀 내용
    const grouped = {};

    // 매입
    if (type === 'purchases') {
      monthlyFinanceList.forEach(({pmfl_account_company_name, pmfl_sales_amount, al_account_bank_name, al_account_bank_no}) => {
        if (!grouped[pmfl_account_company_name]) {
          grouped[pmfl_account_company_name] = {
            '은행명': al_account_bank_name,
            '계좌번호': al_account_bank_no,
            '합계금액': 0,
            '매출처': pmfl_account_company_name,
          }
        }
        grouped[pmfl_account_company_name]['합계금액'] += pmfl_sales_amount + Math.ceil(pmfl_sales_amount * 0.1);
      })
    }
    // 외부인건비
    else if (type === 'outsourcing') {
      monthlyFinanceList.forEach(({pmfl_account_company_name, pmfl_sales_amount, al_account_bank_name, al_account_bank_no}) => {
        if (!grouped[pmfl_account_company_name]) {
          grouped[pmfl_account_company_name] = {
            '은행명': al_account_bank_name,
            '계좌번호': al_account_bank_no,
            '합계금액': 0,
            '성명': pmfl_account_company_name,
            '종류': '급여'
          }
        }
        grouped[pmfl_account_company_name]['합계금액'] += Math.ceil(pmfl_sales_amount * 0.967);
      })
    }

    const excel_list = Object.values(grouped);

    if (excel_list.length > 0) {
      if (type === 'purchases') {
        downloadExcelFile(excel_list, `지급내역_매입_${yearStr}${monthStr}.xlsx`, `${yearStr}${monthStr}`);
      }
      else if (type === 'outsourcing') {
        downloadExcelFile(excel_list, `지급내역_외부인건비_${yearStr}${monthStr}.xlsx`, `${yearStr}${monthStr}`);
      }
    } else {
      alert('조회 목록이 없습니다.');
    }
  };

  useEffect(() => {
    getMonthlyFinanceList();
  }, [selectedDate, pageType, limit]);

  useEffect(() => {
    getMonthlyFinanceList(page);
  }, [orderBy, orderDir]);

  useEffect(() => {
    setPage(1);
    setLimit(30);
    setOrderBy("pmfl_account_company_name");
    setOrderDir("ASC");
  }, [pageType]);

  return (
    <React.Fragment>
      <CustomStack>
        {/* 이전 월 버튼 */}
        <IconButton>
          <ArrowLeftIcon fontSize="large" onClick={() => setSelectedDate(selectedDate.subtract(1, "month"))} />
        </IconButton>
        
        {/* 년도.월 표시 */}
        <Box>
          <Button
            variant="text"
            sx={{ fontSize: "16px", color: "#000" }}
          >
            {selectedDate.year()}.{selectedDate.month() + 1}
          </Button>
        </Box>

        {/* 다음 월 버튼 */}
        <IconButton>
          <ArrowRightIcon fontSize="large" onClick={() => setSelectedDate(selectedDate.add(1, "month"))} />
        </IconButton>
      </CustomStack>

      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
          <Tabs value={pageType} onChange={handleChange}>
            <Tab label="매출" value="sales" />
            <Tab label="매입" value="purchases" />
            <Tab label="외부인건비" value="outsourcing" />
          </Tabs>
        </Box>

        {
          pageType === "sales" && 
          <Sales 
            getMonthlyFinanceList={getMonthlyFinanceList} 
            monthlyFinanceList={monthlyFinanceList}
            monthlyFinanceListTotal={monthlyFinanceListTotal}
            monthlyFinanceListTotalAmount={monthlyFinanceListTotalAmount}
            projectName={projectName} 
            companyName={companyName} 
            setProjectName={setProjectName} 
            setCompanyName={setCompanyName} 
            page={page} 
            setPage={setPage} 
            limit={limit} 
            setLimit={setLimit} 
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            orderDir={orderDir}
            setOrderDir={setOrderDir}
          />
        }
        {
          pageType === "purchases" && 
          <Purchases 
            getSeachExcel={getSeachExcel} 
            getPaymentExcel={getPaymentExcel} 
            getMonthlyFinanceList={getMonthlyFinanceList} 
            monthlyFinanceList={monthlyFinanceList}
            monthlyFinanceListTotal={monthlyFinanceListTotal}
            monthlyFinanceListTotalAmount={monthlyFinanceListTotalAmount}
            projectName={projectName} 
            companyName={companyName} 
            setProjectName={setProjectName} 
            setCompanyName={setCompanyName} 
            page={page} 
            setPage={setPage} 
            limit={limit} 
            setLimit={setLimit} 
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            orderDir={orderDir}
            setOrderDir={setOrderDir}
          />
        }
        {
          pageType === "outsourcing" && 
          <Outsourcing 
            getSeachExcel={getSeachExcel} 
            getPaymentExcel={getPaymentExcel} 
            getMonthlyFinanceList={getMonthlyFinanceList} 
            monthlyFinanceList={monthlyFinanceList} 
            monthlyFinanceListTotal={monthlyFinanceListTotal}
            monthlyFinanceListTotalAmount={monthlyFinanceListTotalAmount}
            projectName={projectName} 
            companyName={companyName} 
            setProjectName={setProjectName} 
            setCompanyName={setCompanyName} 
            page={page} 
            setPage={setPage} 
            limit={limit} 
            setLimit={setLimit} 
            orderBy={orderBy}
            setOrderBy={setOrderBy}
            orderDir={orderDir}
            setOrderDir={setOrderDir}
          />
        }
      </Box>
    </React.Fragment>
  );
};

export default SalesPurchaseManagement;
